import { jsx as o } from "react/jsx-runtime";
import { SvgIcon as t } from "../SvgIcon.js";
const p = (r) => /* @__PURE__ */ o(t, { ...r, children: /* @__PURE__ */ o("path", { d: "M10 0C4.47514 0 0 4.47514 0 10c0 5.5249 4.47514 10 10 10 5.5249 0 10-4.4751 10-10 0-5.52486-4.4751-10-10-10ZM6.53039 6.54144v5.52486H4.47514V4.47514h7.59116v2.05525l-5.53591.01105Zm8.99451 8.98346H7.9337V7.92265h7.5912v7.60225Z" }) });
export {
  p as Duplicate
};
//# sourceMappingURL=Duplicate.js.map
